import axios from "axios";
import { CONST } from "../config/const";

// リストIDグループ一覧
export async function getProductListIDGroups(id: string) {
  try {
    const path = "productListIDGroups";
    const params = { id };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return { sudDatas: [] };
    }
    return { sudDatas: response.data.fetch_data };
  } catch (error) {
    return { sudDatas: [] };
    // logout();
  }
}
